import { ButtonBase, ButtonBaseProps, Fade } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaCheckRounded } from '../icons';

const useStyles = makeStyles({ name: 'CheckCard' })((theme) => ({
	root: {
		position: 'relative',
		display: 'flex',
		alignItems: 'stretch',
		flexDirection: 'column',
		border: 'solid 1px rgba(26, 27, 28, 0.12);',
		padding: '15px',
		paddingBottom: '12px',
		cursor: 'pointer',
		transition: 'box-shadow 125ms ease-out',
		'&.checked': {
			border: theme.palette.mode === 'light'
				? 'solid 1px ' + theme.palette.text.primary
				: 'solid 1px ' + theme.palette.primary.main,
			boxShadow: '0 30px 40px 0 rgba(0, 0, 0, 0.2)'
		}
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: '6px'
	},
	footerValue: {
		fontSize: '18px',
		fontWeight: 'bold'
	},
	footerIcon: {
		fontSize: '31px',
		color: '#4a4a4a',
		opacity: 0.15,
		marginRight: '-5px',
		'&.checked': {
			color: theme.palette.secondary.main,
			'& path': {
				stroke: theme.palette.text.primary
			},
			opacity: 1
		}
	},
	indicator: {
		background: theme.palette.secondary.main,
		position: 'absolute',
		bottom: '-1px',
		left: '-1px',
		right: '-1px',
		height: '6px'
	}
}));

export type CheckCardProps = Omit<ButtonBaseProps, 'classes'> & {
	value?: string;
	checked?: boolean;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const CheckCard: React.FC<CheckCardProps> = (props) => {
	const { value, children, checked, classes, className, ...other } = props;

	let { classes: styles, cx } = useStyles(undefined, { props });

	return (
		<ButtonBase className={cx(styles.root, checked && 'checked', className)} {...other}>
			{children}

			<div className={styles.footer}>
				<span className={styles.footerValue}>{value}</span>
				<SkodaCheckRounded className={cx(styles.footerIcon, checked && 'checked')} />
			</div>

			<Fade in={checked}>
				<div className={styles.indicator} />
			</Fade>
		</ButtonBase>
	);
};
